import { render } from "./SplideCustomPagination.vue?vue&type=template&id=590f3a4a&scoped=true"
import script from "./SplideCustomPagination.vue?vue&type=script&lang=js"
export * from "./SplideCustomPagination.vue?vue&type=script&lang=js"

import "./SplideCustomPagination.vue?vue&type=style&index=0&id=590f3a4a&lang=scss&scoped=true"

import exportComponent from "F:\\work\\1\\s\\vue-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-590f3a4a"]])

export default __exports__